import React from 'react'

import collapsed from './../../../UI/general/collapse.svg'
import close from "./../../../UI/general/close.svg"
import all from './../../../UI/general/all.svg'
import all_white from './../../../UI/general/all_white.svg'

interface Props {
  colorsData: any
  attributesData: any,
  handleSelectTownPlanningFilter: any
  handleMenuSelection: any
  isTownPlanning: any
}

interface State {
  isCollapsed: boolean,
  currentHovered: number,
  currentSelected: number
}

class TownPlanningSidebar extends React.Component<Props,State>{
  constructor(props: Props){
    super(props);
    this.state = {
      isCollapsed: true,
      currentHovered: -1,
      currentSelected: -1
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {
      if(prevProps.isTownPlanning !== this.props.isTownPlanning){
        this.setState({
          isCollapsed: !this.props.isTownPlanning
        })
      }
  }

  render(): React.ReactNode {
      return(
        <React.Fragment>
          <div className={this.state.isCollapsed ? 'sidebar-townplanning-collapsed-btn':'sidebar-townplanning-btn'}
            onClick={() => {this.setState({isCollapsed: !this.state.isCollapsed})}}
          >
            <img src={collapsed} alt=""></img>
          </div>
          <div className={this.state.isCollapsed ? 'sidebar-townplanning-collapsed':'sidebar-townplanning'}>
            <div
              className="properties-close-btn"
              onClick={() => {
                this.setState({
                  currentHovered: -1,
                  currentSelected: -1
                }, () => {
                  this.props.handleMenuSelection('')
                })
              }}
            >
              <img src={close} alt=""></img>
            </div>
            <div className='townplanning-icon-text-container'>
              <div className='townplanning-image-container'>
                <img src={'./UI/menu/urbanismo.svg'} alt=''></img>
              </div>
              <div className='townplanning-text'>URBANISMO</div>
            </div>

            <div className='townplanning-btns-container'>
              {
                this.props.attributesData.map((attribute: any, index: number) => 
                  <div 
                  className='townplanning-selection-btn'
                  key={attribute.name + attribute.id + index}
                  onMouseEnter={() => {this.setState({currentHovered: index})}}
                  onMouseLeave={() => {this.setState({currentHovered: -1})}}
                  onClick={() => {
                    this.setState({
                      currentSelected: index
                    }, () => {
                      this.props.handleSelectTownPlanningFilter(attribute.name)
                    })
                  }}
                  style={{
                    backgroundColor: this.state.currentSelected === index ? this.props.colorsData.main_buttons: this.state.currentHovered === index ? this.props.colorsData.secondary_buttons:"",
                    color: this.state.currentSelected === index ? '#fff': '#000'
                  }}
                  >

                    <img src={this.state.currentSelected === index ? all_white:all} alt=""></img>
                    <div>{attribute.name}</div>
                  </div>
                )
              }
            </div>
          </div>
        </React.Fragment>
      )
  }
}

export default TownPlanningSidebar